// src/js/config/ui/populateConfigSelect.js

import { DOMElements } from '../dom.js';
import { showMessage } from './showMessage.js';
import { getAllOrderConfigs } from '../configLoader.js';

/**
 * Fyller ENDAST dropdown-menyn med sparade konfigurationer.
 * Den försöker inte längre återställa eller förvälja något.
 */
export function populateConfigSelect() {
    const { selectConfig } = DOMElements;
    if (!selectConfig) return;

    while (selectConfig.options.length > 1) {
        selectConfig.remove(1);
    }

    try {
        const savedConfigs = getAllOrderConfigs();
        savedConfigs.sort((a, b) => a.name.localeCompare(b.name));

        savedConfigs.forEach(config => {
            const option = document.createElement('option');
            option.value = config.id;
            option.textContent = config.name;
            selectConfig.appendChild(option);
        });
    } catch (error) {
        console.error("Kunde inte fylla på konfigurationslistan:", error);
        const strings = window.SimP_Strings || {};
        showMessage(strings.populate_config_error || "Kunde inte ladda sparade konfigurationer.", 'error');
    }
}